import React from 'react'
import { colors } from '../../styles'
import styled from 'react-emotion'

const Message = styled('div')`
  border: 1px solid;
  margin: 10px 0;  
  padding: 15px;
  border-radius: 4px;
  background-color: ${props => props.error ? colors.error_bg : colors.tui_blue_25};
  border-color: ${props => props.error ? colors.error_border : colors.tui_dark_blue};
`

export default ({ message, isError }) => (
    <Message error={isError}>{message}</Message>
)